import React from 'react';

function LayoutContent({ element }: { element: JSX.Element }): JSX.Element {
  return <div className="content content--full">{element}</div>;
}

export default LayoutContent;
